import { useEffect, useRef } from 'react';
import classNames from 'classnames';

interface Props {
    message: string;
    fullScreen?: boolean;
    delay?: number;
}

const Loading = ({ message, fullScreen = false, delay = 300 }: Props) => {
    const loaderRef = useRef<HTMLElement>(null);
    const loaderClass = classNames('loader-wrapper', {
        'full-screen': fullScreen,
        'is-delayed': delay > 0,
    });

    useEffect(() => {
        const timer =
            delay > 0
                ? setTimeout(() => {
                      loaderRef?.current?.classList.remove('is-delayed');
                  }, delay)
                : undefined;

        return () => timer && clearTimeout(timer);
    }, [delay]);

    return (
        <section className={loaderClass} ref={loaderRef} data-testid="LoadingSpinner">
            {fullScreen ? (
                <img
                    className="pulse"
                    src="/img/automate-logo.svg"
                    alt={message}
                    width={48}
                    height={48}
                />
            ) : (
                <div className="spinner" />
            )}
            <span>{message}</span>
        </section>
    );
};

export default Loading;
